exports.slug2path = (slug) => slug.replace(/\/([^/]*)\/\1\.\w{2,3}\//g, "/$1/");
